/**
 * ballstories Bücherregal – Storefront page with Customer Account API (OAuth PKCE).
 */
(function () {
  'use strict';

  if (window.__bsBookshelfApp) return;
  window.__bsBookshelfApp = true;

  const STORAGE_KEY = 'bs_br_session_v2';
  const PKCE_KEY = 'bs_br_pkce_v1';
  const BOOKS_CACHE_KEY = 'bs_br_books_cache_v1';
  const DETAIL_CACHE_PREFIX = 'bs_br_detail_v1_';
  const CACHE_TTL_MS = 15 * 60 * 1000;

  const el = document.getElementById('bs-buecherregal');
  const root = document.getElementById('bs-br-root');
  const heroActions = document.getElementById('bs-br-hero-actions');
  const logoutBtn = document.getElementById('bs-br-logout');
  const loadingOverlay = document.getElementById('bs-br-loading-overlay');
  const loadingText = document.getElementById('bs-br-loading-text');
  if (!el || !root) return;

  let overlayEl = loadingOverlay;
  let overlayTextEl = loadingText;

  function injectLoadingStyles() {
    if (document.getElementById('bs-loading-overlay-styles')) return;
    const style = document.createElement('style');
    style.id = 'bs-loading-overlay-styles';
    style.textContent =
      '.bs-loading-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:1.5rem;background:rgba(255,255,255,.45);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px)}' +
      '.bs-loading-overlay[hidden]{display:none!important}' +
      'body.bs-loading-overlay-open{overflow:hidden}' +
      '.bs-loading-overlay__card{display:flex;flex-direction:column;align-items:center;gap:.875rem;max-width:20rem;text-align:center}' +
      '.bs-loading-overlay__spinner{--bs-loader-track:#e5e7eb;--bs-loader-accent:#16a34a;--bs-loader-size:1px;width:calc(48*var(--bs-loader-size));height:calc(48*var(--bs-loader-size));border:calc(5*var(--bs-loader-size)) solid var(--bs-loader-track);border-bottom-color:var(--bs-loader-accent);border-radius:50%;display:inline-block;box-sizing:border-box;animation:bs-loading-spin 1s linear infinite}' +
      '.bs-loading-overlay__text{margin:0;font-family:Comfortaa,system-ui,sans-serif;font-size:.9375rem;font-weight:500;color:#6b7280;text-align:center}' +
      '@keyframes bs-loading-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(style);
  }

  function ensureLoadingOverlay() {
    injectLoadingStyles();
    if (overlayEl) return overlayEl;

    overlayEl = document.createElement('div');
    overlayEl.id = 'bs-br-loading-overlay';
    overlayEl.className = 'bs-loading-overlay';
    overlayEl.hidden = true;
    overlayEl.setAttribute('aria-hidden', 'true');
    overlayEl.innerHTML =
      '<div class="bs-loading-overlay__card" role="status" aria-live="polite" aria-busy="true">' +
      '<span class="bs-loading-overlay__spinner" aria-hidden="true"></span>' +
      '<p class="bs-loading-overlay__text" id="bs-br-loading-text">Wird geladen …</p>' +
      '</div>';
    document.body.appendChild(overlayEl);
    overlayTextEl = overlayEl.querySelector('#bs-br-loading-text');
    return overlayEl;
  }

  function showLoading(message) {
    ensureLoadingOverlay();
    if (overlayTextEl) overlayTextEl.textContent = message || 'Wird geladen …';
    overlayEl.hidden = false;
    overlayEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bs-loading-overlay-open');
  }

  function hideLoading() {
    if (!overlayEl) return;
    overlayEl.hidden = true;
    overlayEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bs-loading-overlay-open');
  }

  const config = {
    shopDomain: el.dataset.shopDomain || '',
    clientId: el.dataset.clientId || '',
    fnBase: (el.dataset.fnBase || '').replace(/\/$/, ''),
    createUrl: el.dataset.createUrl || '/products/fussball-kinderbuch',
    redirectUri: el.dataset.redirectUri || window.location.origin + window.location.pathname,
    loggedInStorefront: el.dataset.loggedInStorefront === 'true',
  };

  let books = [];
  let view = 'list';
  let detail = null;
  let activeDetailId = null;
  let routeSyncing = false;
  let starting = new Set();
  let discovery = null;

  function getRouteFromHash() {
    const raw = (window.location.hash || '').replace(/^#/, '').trim();
    if (raw.startsWith('buch/')) {
      const bookId = decodeURIComponent(raw.slice(5).split(/[/?&]/)[0] || '');
      if (bookId) return { name: 'detail', bookId };
    }
    return { name: 'list' };
  }

  function hashForRoute(name, bookId) {
    return name === 'detail' ? `#buch/${encodeURIComponent(bookId)}` : '#liste';
  }

  function setRouteHash(name, bookId, replace) {
    const hash = hashForRoute(name, bookId);
    const url = window.location.pathname + window.location.search + hash;
    if (window.location.pathname + window.location.search + window.location.hash === url) return;
    routeSyncing = true;
    if (replace) history.replaceState({ bsBr: 1 }, '', url);
    else history.pushState({ bsBr: 1 }, '', url);
    routeSyncing = false;
  }

  async function syncRouteFromHash() {
    if (routeSyncing) return;

    const route = getRouteFromHash();
    const session = loadSession();
    const authenticated = session && (isSessionValid(session) || session.refreshToken);

    if (heroActions) heroActions.hidden = !authenticated;

    if (!authenticated) {
      view = 'list';
      detail = null;
      activeDetailId = null;
      root.innerHTML = renderGate();
      document.getElementById('bs-br-login-btn')?.addEventListener('click', () =>
        handleGateAction().catch(console.error)
      );
      return;
    }

    if (route.name === 'detail') {
      await openDetail(route.bookId);
      return;
    }

    await openList();
  }

  async function openList() {
    view = 'list';
    detail = null;
    activeDetailId = null;

    if (restoreBooksFromCache() || books.length) {
      renderListView();
      return;
    }

    showLoading('Deine Bücher werden geladen …');
    try {
      await loadBooks({ forceNetwork: true });
      renderListView();
    } catch (e) {
      if (e.message === 'not_authenticated' || e.status === 401) {
        clearSession();
        books = [];
        setRouteHash('list', null, true);
        root.innerHTML = `
          <div class="bs-br__login">
            ${renderError('Anmeldung konnte nicht bestätigt werden. Bitte erneut versuchen.')}
            <button type="button" class="bs-btn bs-btn--primary" id="bs-br-login-btn">Erneut anmelden</button>
          </div>
        `;
        document.getElementById('bs-br-login-btn')?.addEventListener('click', () =>
          handleGateAction().catch(console.error)
        );
        return;
      }
      root.innerHTML = renderError('Bücher konnten nicht geladen werden. Bitte Seite neu laden.');
    } finally {
      hideLoading();
    }
  }

  async function openDetail(bookId) {
    if (!bookId) {
      setRouteHash('list', null, true);
      await openList();
      return;
    }

    if (view === 'detail' && activeDetailId === bookId && detail) {
      root.innerHTML = renderDetailView();
      bindDetailEvents();
      return;
    }

    view = 'detail';
    activeDetailId = bookId;
    detail = null;
    root.innerHTML = '';

    const cached = loadDetailCache(bookId);
    if (!cached) showLoading('Details werden geladen …');

    try {
      if (cached) {
        detail = cached;
        root.innerHTML = renderDetailView();
        bindDetailEvents();
      }
      detail = await loadDetail(bookId, { useCache: !cached, forceNetwork: !!cached });
      root.innerHTML = renderDetailView();
      bindDetailEvents();
    } catch {
      setRouteHash('list', null, true);
      await openList();
      root.innerHTML = renderError('Details konnten nicht geladen werden.');
    } finally {
      hideLoading();
    }
  }

  // ---------------------------------------------------------------------------
  // PKCE helpers
  // ---------------------------------------------------------------------------
  function randomString(len) {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    return Array.from(arr, (b) => ('0' + b.toString(16)).slice(-2)).join('');
  }

  function base64UrlEncode(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = '';
    for (const b of bytes) str += String.fromCharCode(b);
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  async function sha256(text) {
    const data = new TextEncoder().encode(text);
    return crypto.subtle.digest('SHA-256', data);
  }

  async function createPkcePair() {
    const arr = new Uint8Array(32);
    crypto.getRandomValues(arr);
    const verifier = base64UrlEncode(arr);
    const challenge = base64UrlEncode(await sha256(verifier));
    return { verifier, challenge };
  }

  // ---------------------------------------------------------------------------
  // Session storage
  // ---------------------------------------------------------------------------
  function loadSession() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function saveSession(session) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  }

  function clearSession() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(BOOKS_CACHE_KEY);
    sessionStorage.removeItem(PKCE_KEY);
    clearDetailCache();
  }

  function hasStoredSession() {
    const session = loadSession();
    return !!(session?.accessToken || session?.refreshToken);
  }

  function sessionMarker() {
    const session = loadSession();
    if (!session) return null;
    const token = session.refreshToken || session.accessToken;
    return token ? String(token).slice(-20) : null;
  }

  function loadBooksCache() {
    try {
      const raw = localStorage.getItem(BOOKS_CACHE_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.marker !== sessionMarker()) return null;
      if (Date.now() - data.fetchedAt > CACHE_TTL_MS) return null;
      return Array.isArray(data.books) ? data.books : null;
    } catch {
      return null;
    }
  }

  function saveBooksCache(list) {
    const marker = sessionMarker();
    if (!marker) return;
    localStorage.setItem(
      BOOKS_CACHE_KEY,
      JSON.stringify({ marker, fetchedAt: Date.now(), books: list })
    );
  }

  function clearDetailCache() {
    try {
      for (let i = localStorage.length - 1; i >= 0; i -= 1) {
        const key = localStorage.key(i);
        if (key && key.startsWith(DETAIL_CACHE_PREFIX)) localStorage.removeItem(key);
      }
    } catch {
      /* ignore */
    }
  }

  function loadDetailCache(bookId) {
    try {
      const raw = localStorage.getItem(DETAIL_CACHE_PREFIX + bookId);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.marker !== sessionMarker()) return null;
      if (Date.now() - data.fetchedAt > CACHE_TTL_MS) return null;
      return data.detail || null;
    } catch {
      return null;
    }
  }

  function saveDetailCache(bookId, detailData) {
    const marker = sessionMarker();
    if (!marker || !bookId) return;
    localStorage.setItem(
      DETAIL_CACHE_PREFIX + bookId,
      JSON.stringify({ marker, fetchedAt: Date.now(), detail: detailData })
    );
  }

  function isSessionValid(session) {
    if (!session?.accessToken) return false;
    if (!session.expiresAt) return true;
    return Date.now() < session.expiresAt - 60_000;
  }

  // ---------------------------------------------------------------------------
  // Discovery + OAuth
  // ---------------------------------------------------------------------------
  async function getOpenIdConfig() {
    if (discovery) return discovery;
    const res = await fetch(`https://${config.shopDomain}/.well-known/openid-configuration`);
    if (!res.ok) throw new Error('OpenID discovery failed');
    discovery = await res.json();
    return discovery;
  }

  async function startLogin() {
    const oidc = await getOpenIdConfig();
    const { verifier, challenge } = await createPkcePair();
    const state = randomString(16);
    sessionStorage.setItem(
      PKCE_KEY,
      JSON.stringify({ verifier, state, redirectUri: config.redirectUri })
    );

    const url = new URL(oidc.authorization_endpoint);
    url.searchParams.set('scope', 'openid email customer-account-api:full');
    url.searchParams.set('client_id', config.clientId);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('redirect_uri', config.redirectUri);
    url.searchParams.set('state', state);
    url.searchParams.set('code_challenge', challenge);
    url.searchParams.set('code_challenge_method', 'S256');
    url.searchParams.set('locale', 'de');
    window.location.href = url.toString();
  }

  async function exchangeCode(code) {
    const pkceRaw = sessionStorage.getItem(PKCE_KEY);
    if (!pkceRaw) throw new Error('PKCE state missing');
    const pkce = JSON.parse(pkceRaw);

    const res = await fetch(`${config.fnBase}/caapiTokenExchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grantType: 'authorization_code',
        shopDomain: config.shopDomain,
        clientId: config.clientId,
        code,
        redirectUri: pkce.redirectUri || config.redirectUri,
        codeVerifier: pkce.verifier,
      }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Token exchange failed');
    return data;
  }

  async function refreshAccessToken(refreshToken) {
    const res = await fetch(`${config.fnBase}/caapiTokenExchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        grantType: 'refresh_token',
        shopDomain: config.shopDomain,
        clientId: config.clientId,
        refreshToken,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Refresh failed');
    return data;
  }

  async function ensureAccessToken() {
    let session = loadSession();
    if (session && isSessionValid(session)) return session.accessToken;

    if (session?.refreshToken) {
      try {
        const data = await refreshAccessToken(session.refreshToken);
        session = {
          accessToken: data.access_token,
          idToken: data.id_token || session.idToken || null,
          refreshToken: data.refresh_token || session.refreshToken,
          expiresAt: data.expires_in ? Date.now() + data.expires_in * 1000 : null,
        };
        saveSession(session);
        return session.accessToken;
      } catch {
        clearSession();
      }
    }
    return null;
  }

  async function handleOAuthCallback() {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (!code) return false;

    const pkceRaw = sessionStorage.getItem(PKCE_KEY);
    if (pkceRaw) {
      const pkce = JSON.parse(pkceRaw);
      if (pkce.state && state && pkce.state !== state) {
        throw new Error('OAuth state mismatch');
      }
    }

    const data = await exchangeCode(code);
    saveSession({
      accessToken: data.access_token,
      idToken: data.id_token || null,
      refreshToken: data.refresh_token || null,
      expiresAt: data.expires_in ? Date.now() + data.expires_in * 1000 : null,
    });
    sessionStorage.removeItem(PKCE_KEY);

    const clean = window.location.pathname + window.location.search + '#liste';
    window.history.replaceState({}, '', clean);
    return true;
  }

  // ---------------------------------------------------------------------------
  // API calls
  // ---------------------------------------------------------------------------
  async function apiPost(path, body) {
    const session = loadSession();
    const token = await ensureAccessToken();
    if (!token) throw new Error('not_authenticated');

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };
    if (session?.idToken) {
      headers['X-CAAPI-Id-Token'] = session.idToken;
    }

    const res = await fetch(`${config.fnBase}/${path}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ ...body, shopDomain: config.shopDomain }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      if (res.status === 401) {
        clearSession();
      }
      const err = new Error(data.error || `API error ${res.status}`);
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  }

  async function loadBooks(options) {
    const opts = options || {};
    const hadBooks = books.length > 0;

    if (opts.useCache !== false) {
      const cached = loadBooksCache();
      if (cached && cached.length) {
        books = cached;
        if (!opts.forceNetwork) return books;
      }
    }

    const data = await apiPost('listCustomerBooksPublic', {});
    const fresh = Array.isArray(data.books) ? data.books : [];
    // Hintergrund-Refresh: leere Antwort nicht über bestehende Liste drüberbügeln.
    if (fresh.length || !hadBooks) {
      books = fresh;
      saveBooksCache(books);
    }
    return books;
  }

  async function loadDetail(bookId, options) {
    const opts = options || {};
    if (opts.useCache !== false) {
      const cached = loadDetailCache(bookId);
      if (cached) {
        if (!opts.forceNetwork) return cached;
      }
    }

    const data = await apiPost('getCustomerBookPublic', { bookId });
    saveDetailCache(bookId, data);
    return data;
  }

  async function startFolgebuch(bookId) {
    if (starting.has(bookId)) return;
    starting.add(bookId);
    showLoading('Folgebuch wird vorbereitet …');
    try {
      const data = await apiPost('folgebuchStartPublic', { bookId });
      if (data.redirectUrl) {
        window.location.href = data.redirectUrl;
        return;
      }
      hideLoading();
      starting.delete(bookId);
      render();
    } catch (e) {
      console.error('[bs-buecherregal] Folgebuch start failed', e);
      hideLoading();
      starting.delete(bookId);
      render();
    }
  }

  // ---------------------------------------------------------------------------
  // Rendering helpers (port from Buecherregal.tsx / MeinKonto.vue)
  // ---------------------------------------------------------------------------
  function badgeLabel(cls) {
    if (cls === 'status-versand') return 'Versand';
    if (cls === 'status-druck') return 'In Druck';
    return 'In Arbeit';
  }

  function buildSeries(list) {
    const byId = new Map(list.map((b) => [b.id, b]));
    const sorted = [...list].sort((a, b) => a.createdAtMs - b.createdAtMs);
    const used = new Set();
    const series = [];
    const roots = sorted.filter((b) => !b.parentBookId || !byId.has(b.parentBookId));
    for (const r of roots) {
      if (used.has(r.id)) continue;
      const chain = [r];
      used.add(r.id);
      let current = r;
      for (;;) {
        const next = sorted.find((x) => x.parentBookId === current.id && !used.has(x.id));
        if (!next) break;
        chain.push(next);
        used.add(next.id);
        current = next;
      }
      series.push(chain);
    }
    for (const b of sorted) {
      if (!used.has(b.id)) {
        used.add(b.id);
        series.push([b]);
      }
    }
    return series;
  }

  function groupByChild(list) {
    const map = new Map();
    for (const b of list) {
      const key = b.childKey || b.id;
      if (!map.has(key)) {
        map.set(key, { displayName: b.childDisplayName || b.childName || '', books: [] });
      }
      map.get(key).books.push(b);
    }
    const sections = [...map.values()];
    sections.sort((a, b) => {
      const am = Math.min(...a.books.map((x) => x.createdAtMs || 0));
      const bm = Math.min(...b.books.map((x) => x.createdAtMs || 0));
      return am - bm;
    });
    return sections;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderCard(book, clickable) {
    const badge = book.badge || {};
    const coverHtml =
      book.showCover && book.coverUrl
        ? `<img src="${escapeHtml(book.coverUrl)}" alt="${escapeHtml(book.title)}" class="bs-br__card-img" loading="lazy" />`
        : `<span class="bs-br__card-placeholder-text">Cover noch nicht verfügbar</span>`;

    const tag = clickable ? 'a' : 'div';
    const attrs = clickable
      ? `href="${hashForRoute('detail', book.id)}" class="bs-br__card bs-br__card--clickable" data-book-id="${escapeHtml(book.id)}"`
      : `class="bs-br__card bs-br__card--placeholder"`;

    return `
      <${tag} ${attrs}>
        <div class="bs-br__card-cover${book.showCover && book.coverUrl ? '' : ' bs-br__card-cover--placeholder'}">
          ${coverHtml}
          <div class="bs-br__card-cover-title" aria-hidden="true">
            <span class="bs-br__card-cover-line1">${escapeHtml(book.headtitle)}</span>
            <span class="bs-br__card-cover-line2">${escapeHtml(book.titleLine2)}</span>
          </div>
          <span class="bs-br__badge ${escapeHtml(badge.class || '')}">${escapeHtml(badge.label || badgeLabel(badge.class))}</span>
          ${clickable ? '<div class="bs-br__card-overlay"><span>Details →</span></div>' : '<div class="bs-br__card-overlay"><span>In Bearbeitung</span></div>'}
        </div>
      </${tag}>
    `;
  }

  function renderList() {
    if (!books.length) {
      return `
        <div class="bs-br__empty">
          <h1>Noch kein ballstories Buch?</h1>
          <p>Das Bücherregal ist erst nach deiner ersten Bestellung verfügbar. Leg jetzt den Grundstein Deiner Buchserie.</p>
          <a href="${escapeHtml(config.createUrl)}" class="bs-btn bs-btn--primary">Buch bestellen</a>
        </div>
      `;
    }

    const sections = groupByChild(books);
    let html = '<div class="bs-br__sections">';

    for (const section of sections) {
      const title = section.displayName
        ? `${escapeHtml(section.displayName)} ballstories`
        : 'ballstories';
      const chains = buildSeries(section.books);
      const parentIds = new Set(section.books.map((b) => b.parentBookId).filter(Boolean));

      html += `<section class="bs-br__section"><h2 class="bs-br__section-title bs-trademark-skip">${title}</h2><div class="bs-br__grid">`;

      for (const chain of chains) {
        html += '<div class="bs-br__chain-wrapper"><div class="bs-br__chain">';
        for (const book of chain) {
          html += renderCard(book, !!book.showCover);
          html += `<div class="bs-br__chain-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" width="20" height="20"><path d="M5 12h14M12 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></div>`;
        }
        const tail = chain[chain.length - 1];
        if (tail.showCover && !parentIds.has(tail.id)) {
          html += `
            <button type="button" class="bs-br__folgebuch" data-folgebuch-id="${escapeHtml(tail.id)}">
              <span class="bs-br__folgebuch-cta">Erstelle jetzt dein Folgebuch</span>
              <span class="bs-br__folgebuch-hint">Teamausflug, Turnier, Probetraining – lass deiner Fantasie freien Lauf!</span>
            </button>
          `;
        }
        html += '</div></div>';
      }

      html += `
        <a href="${escapeHtml(config.createUrl)}" class="bs-br__new-series">
          <span class="bs-br__new-series-icon">+</span>
          <span class="bs-br__new-series-label">Neue Buchreihe starten</span>
          <span class="bs-br__new-series-hint">Buch bestellen</span>
        </a>
      `;
      html += '</div></section>';
    }

    html += '</div>';
    return html;
  }

  function renderDetailView() {
    if (!detail) return '';

    const d = detail;
    let html = `
      <a href="#liste" class="bs-br__back" id="bs-br-back">← Zurück zum Regal</a>
    `;

    if (d.trackingUrl) {
      html += `<p class="bs-br__tracking"><a href="${escapeHtml(d.trackingUrl)}" target="_blank" rel="noopener">📦 Sendung verfolgen</a></p>`;
    }

    html += `<div class="bs-br__detail-head">`;
    if (d.coverUrl) {
      html += `
        <div class="bs-br__detail-cover">
          <img src="${escapeHtml(d.coverUrl)}" alt="${escapeHtml(d.titleLine2)}" loading="lazy" />
        </div>
      `;
    }
    html += `
      <div class="bs-br__detail-meta">
        <span class="bs-br__badge ${escapeHtml(d.badgeClass || '')}">${escapeHtml(badgeLabel(d.badgeClass))}</span>
        <h2>${escapeHtml(d.titleLine2)}</h2>
        ${d.orderDate ? `<p class="bs-br__detail-date">Bestellt am ${escapeHtml(d.orderDate)}</p>` : ''}
        ${d.summary ? `<p class="bs-br__detail-summary">${escapeHtml(d.summary)}</p>` : ''}
        ${d.canFolgebuch ? `<button type="button" class="bs-btn bs-btn--primary bs-btn--sm" data-folgebuch-id="${escapeHtml(d.id)}">Folgebuch erstellen</button>` : ''}
      </div>
    </div>`;

    for (const sec of d.sections || []) {
      html += `<div class="bs-br__detail-section"><h3>${escapeHtml(sec.emoji)} ${escapeHtml(sec.heading)}</h3>`;
      for (const row of sec.rows || []) {
        html += `<p class="bs-br__detail-row">${escapeHtml(row)}</p>`;
      }
      html += '</div>';
    }

    if (d.chapterImages && d.chapterImages.length) {
      html += '<div class="bs-br__detail-section"><h3>🖼️ Kapitelbilder</h3><div class="bs-br__chapter-grid">';
      for (const url of d.chapterImages) {
        html += `<img src="${escapeHtml(url)}" alt="Kapitelbild" loading="lazy" />`;
      }
      html += '</div></div>';
    }

    return html;
  }

  function renderGate() {
    const canLoad = hasStoredSession();
    const shopLoggedIn = config.loggedInStorefront;
    const lead = canLoad
      ? 'Tippe auf den Button, um deine Bücher, Cover und Folgebuch-Optionen zu laden.'
      : shopLoggedIn
        ? 'Du bist im Shop angemeldet. Zeige deine Bücher an – dafür bestätigen wir kurz dein Kundenkonto.'
        : 'Melde dich mit deinem ballstories-Kundenkonto an, um deine Bücher zu sehen.';
    const btnLabel = canLoad
      ? 'Meine Bücher laden'
      : shopLoggedIn
        ? 'Meine Bücher anzeigen'
        : 'Jetzt anmelden';

    return `
      <div class="bs-br__login">
        <p class="bs-br__login-lead">${escapeHtml(lead)}</p>
        <button type="button" class="bs-btn bs-btn--primary" id="bs-br-login-btn">${escapeHtml(btnLabel)}</button>
      </div>
    `;
  }

  async function handleGateAction() {
    const btn = document.getElementById('bs-br-login-btn');
    if (btn) {
      btn.disabled = true;
      btn.textContent = hasStoredSession() ? 'Bücher werden geladen …' : 'Weiterleitung …';
    }
    if (hasStoredSession()) {
      showLoading('Deine Bücher werden geladen …');
      await initAuthenticated();
      return;
    }
    await startLogin();
  }

  function restoreBooksFromCache() {
    if (books.length) return true;
    const cached = loadBooksCache();
    if (Array.isArray(cached) && cached.length) {
      books = cached;
      return true;
    }
    return false;
  }

  function renderListView() {
    root.innerHTML = renderList();
    bindListEvents();
  }

  async function ensureListLoaded() {
    setRouteHash('list', null, true);
    await openList();
  }

  function render() {
    syncRouteFromHash().catch(console.error);
  }

  function renderError(msg) {
    return `<div class="bs-br__alert bs-br__alert--error" role="alert">${escapeHtml(msg)}</div>`;
  }

  function bindListEvents() {
    root.querySelectorAll('[data-folgebuch-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-folgebuch-id');
        if (id) startFolgebuch(id);
      });
    });
  }

  function bindDetailEvents() {
    root.querySelectorAll('[data-folgebuch-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('data-folgebuch-id');
        if (id) startFolgebuch(id);
      });
    });
  }

  async function initAuthenticated() {
    const cached = loadBooksCache();
    if (cached?.length) {
      books = cached;
      if (heroActions) heroActions.hidden = false;
      hideLoading();

      loadBooks({ forceNetwork: true })
        .then(() => {
          if (view === 'list') renderListView();
        })
        .catch((e) => {
          if (e.message !== 'not_authenticated' && e.status !== 401) {
            console.warn('[bs-buecherregal] Hintergrund-Aktualisierung fehlgeschlagen', e);
          }
        });

      await syncRouteFromHash();
      return;
    }

    showLoading('Deine Bücher werden geladen …');
    try {
      await loadBooks({ forceNetwork: true });
      if (heroActions) heroActions.hidden = false;
      await syncRouteFromHash();
    } catch (e) {
      if (e.message === 'not_authenticated' || e.status === 401) {
        clearSession();
        root.innerHTML = `
          <div class="bs-br__login">
            ${renderError('Anmeldung konnte nicht bestätigt werden. Bitte erneut versuchen.')}
            <button type="button" class="bs-btn bs-btn--primary" id="bs-br-login-btn">Erneut anmelden</button>
          </div>
        `;
        document.getElementById('bs-br-login-btn')?.addEventListener('click', () => handleGateAction().catch(console.error));
        return;
      }
      root.innerHTML = renderError('Bücher konnten nicht geladen werden. Bitte Seite neu laden.');
    } finally {
      hideLoading();
    }
  }

  logoutBtn?.addEventListener('click', () => {
    clearSession();
    view = 'list';
    detail = null;
    activeDetailId = null;
    books = [];
    setRouteHash('list', null, true);
    syncRouteFromHash().catch(console.error);
  });

  window.addEventListener('hashchange', () => {
    syncRouteFromHash().catch(console.error);
  });
  window.addEventListener('popstate', () => {
    syncRouteFromHash().catch(console.error);
  });

  (async function bootstrap() {
    try {
      const hadCallback = await handleOAuthCallback().catch((e) => {
        console.error('[bs-buecherregal] OAuth callback error', e);
        hideLoading();
        root.innerHTML = renderError('Anmeldung fehlgeschlagen. Bitte erneut versuchen.');
        return false;
      });

      if (hadCallback) {
        showLoading('Anmeldung wird abgeschlossen …');
        await initAuthenticated();
        return;
      }

      await syncRouteFromHash();
    } catch (e) {
      console.error('[bs-buecherregal] init failed', e);
      root.innerHTML = renderError('Ein Fehler ist aufgetreten.');
    }
  })();
})();
